import { PropsWithChildren, ReactNode } from 'react';

import { cn } from '@accio3d/design-system/utils';

import arcessioLogoSrc from '../../assets/arcessio-icon.svg';

/** The assistant's mark.
 * @param props.variant 'outline' (default) for the tinted chip, 'solid' for a filled berry-gradient badge
 * @returns the badge
 */
export function ArcessioBadge({ variant = 'outline' }: { variant?: 'outline' | 'solid' }) {
  return (
    <div
      className={cn(
        'h-8 w-8 rounded-sm flex items-center justify-center shrink-0',
        variant === 'solid'
          ? 'bg-[image:var(--gradient-primary)]'
          : 'border border-primary/25 bg-primary/5',
      )}
    >
      <img
        alt="Arcessio"
        className={cn(
          'h-4 w-4 shrink-0 object-contain',
          variant === 'solid' && 'brightness-0 invert',
        )}
        src={arcessioLogoSrc}
      />
    </div>
  );
}

export function ArcessioInsightsContainer(
  props: PropsWithChildren<{ className?: string; headerExtra?: ReactNode }>,
) {
  return (
    <div className="w-full rounded-sm! overflow-hidden arcessio-panel @container/arcessioAiInsights">
      <div className="h-[3px] bg-primary/30" />
      <div className="px-4 py-3 border-b border-border bg-muted/40">
        <div className="flex flex-col @sm/arcessioAiInsights:flex-row items-center gap-0 @sm/arcessioAiInsights:gap-2.5">
          <div className="flex gap-2.5 items-center">
            <ArcessioBadge />
            <span className="text-base font-semibold text-foreground">Arcessio Insights</span>
          </div>
          {props.headerExtra}
        </div>
      </div>

      <div className={props.className}>{props.children}</div>
    </div>
  );
}
